export default "__VITE_ASSET__DCD1ZrDK__"